import { FormikProvider } from 'formik';

import { Typography, Grid } from '@mui/material';

import GuestDetail from './GuestDetail';

import StyledTextField from '@shared/components/StyledTextField';

import RoomsForm from './RoomsForm';

import BookingPayeeSection from './BookingPayeeSection';
import FormSection from '@shared/components/FormSection';

import SubmitButton from '@shared/components/Buttons/SubmitButton';
import TermsAndConditionsCheckbox from '@shared/components/TermsAndConditionsCheckbox';
import Remarks from '../helpers/Remarks/Remarks';
import { hasValidContent } from '@shared/pages/Hotels/helpers/Remarks/hasValidContent';

const BookingForm = ({
  formik,
  roomsArray,
  search,
  cancelationFee,
  isaBuying,
  isLoadingPay,
  payee,
  submittingRef,
  room,
  hotelsValidateResult,
}) => {
  const hasRemarks =
    hasValidContent(room?.general_comments) ||
    hasValidContent(cancelationFee?.general_comments) ||
    hasValidContent(hotelsValidateResult?.comments) ||
    hasValidContent(hotelsValidateResult?.remarks);

  return (
    <FormikProvider value={formik}>
      <form onSubmit={formik.handleSubmit} autoComplete="off">
        {/* -------------HABITACION-------------- */}
        <RoomsForm roomsArray={roomsArray} formik={formik} search={search} />

        <FormSection
          title="Datos de contacto"
          customLayout={{
            xs: {
              1: 12,
              2: 12,
              3: 12,
              4: 12,
              5: 12,
            },
            md: {
              1: 12,
              2: 5,
              3: 5,
              4: 2,
              5: 12,
            },
          }}
        >
          <Typography
            style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#5e5e5e',
            }}
          >
            Los datos que nos brindes serán fundamentales para que gestiones tu
            reserva y recibas información importante sobre la misma.
          </Typography>
          <StyledTextField formik={formik} name="email" label="E-mail" />
          <StyledTextField
            formik={formik}
            name="emailValidation"
            label="Confirme E-mail"
          />
          <StyledTextField formik={formik} name="phone" label="Teléfono" />
          <Grid item xs={12} md={12}>
            <StyledTextField
              multiline
              label="Información adicional"
              name="comments"
              formik={formik}
            />
          </Grid>
        </FormSection>

        <BookingPayeeSection
          payee={payee}
          formik={formik}
          isaBuying={isaBuying}
          cancelationFee={cancelationFee}
          search={search}
        />

        <GuestDetail copyPassenger={formik.values.passengers} />

        {hasRemarks && (
          <FormSection title={'Observaciones'} mdVal={12}>
            <Remarks
              room={room}
              hotelsValidateResult={{
                remarks: hotelsValidateResult?.remarks,
                comments: hotelsValidateResult?.comments,
              }}
              buttonClose={false}
              preview
              cancelationFee={cancelationFee}
            />
          </FormSection>
        )}

        {/* Checkbox de términos y condiciones */}
        <Grid container alignItems="center" sx={{ mt: 1, mb: 2 }}>
          <TermsAndConditionsCheckbox
            formik={formik}
            fieldName="acceptedTerms"
            dialogText="Términos y condiciones generales, condiciones de compra y políticas de cancelación."
          />
        </Grid>

        {/* Mensaje de error general */}
        {formik?.values?.acceptedTerms && !!Object.keys(formik.errors).length && (
          <Grid sx={{ pl: 1 }}>
            <Typography
              sx={{ fontSize: { xs: '16px', md: '18px' }, fontWeight: '600' }}
              color="error"
            >
              Verifique que haya ingresado todos los datos del formulario antes
              de continuar con la reserva.
            </Typography>
          </Grid>
        )}

        {/* Botón de confirmar */}
        <Grid style={{ display: 'flex', justifyContent: 'center' }}>
          <SubmitButton
            isLoading={
              isLoadingPay || formik.isSubmitting || submittingRef.current
            }
            buttonText={isaBuying ? 'Continuar' : 'Reservar'}
          />
        </Grid>
      </form>
    </FormikProvider>
  );
};

export default BookingForm;
